// ##############################
// // // MultiInput component styles
// #############################

const multiInputStyle = {
    addBtn: {
        padding: '8px 7px 8px 7px',
        background:"#4caf50",
        border: 'none',
        color: 'white'
    },
    input: {padding: '6px 7px 6px 7px'},
    valuesBox: {height:'95px', overflowX:'auto', border: '1px solid silver'},
    valueItem: {borderBottom: '1px solid silver', padding:'5px'},
    removeItemBtn: {
        background:"red",
        color:"white",
        padding: '0 5px 0 5px',
        fontWeight: 'bold',
        cursor: "pointer",
        float: "right"
      }
  };
  
  export default multiInputStyle;


// WEBPACK FOOTER //
// ./src/assets/jss/material-dashboard-pro-react/components/multiInputStyle.jsx